

/**
 * @fileoverview Interpret browser/runtime flags controlling visibility of historical drafting tools. The backend independently owns feature admission, run limits, and provider execution. Showing a test workspace does not start generation or authorize historical processing.
 */

function enabledValue(value) {
  if (value === true) return true;
  return ['1', 'true', 'yes', 'on'].includes(String(value || '').trim().toLowerCase());
}



export function isHistoricalDraftingTestingEnabled({
  runtimeConfig = window.__KC_RUNTIME_CONFIG__ || {},
  buildValue = process.env.REACT_APP_MATTER_DRAFTING_HISTORICAL_TESTING_ENABLED,
} = {}) {
  return enabledValue(runtimeConfig.matterDraftingHistoricalTestingEnabled)
    || enabledValue(buildValue);
}
